<template>
    <div id="ShopIndex">
        <IndexBottom></IndexBottom>
        <div class="rightNav">
            <ul>
                <li @mouseenter="hover1=true" @mouseleave="hover1=false" @click="goPersonal()">
                    <i class="el-icon-user"></i>
                    <p class="hovers hover1" v-show="hover1">进入个人中心</p>
                </li>
                <li @mouseenter="hover2=true" @mouseleave="hover2=false" @click="goCar()">
                    <i class="fa fa-shopping-cart"></i>
                    <p class="hovers hover2" v-show="hover2">进入购物车</p>
                </li>
                <li @mouseenter="hover3=true" @mouseleave="hover3=false">
                    <i class="fa fa-qrcode"></i>
                    <p class="hovers hover3" v-show="hover3">
                        <img src="@/assets/img/two.png" alt />
                    </p>
                </li>
            </ul>
             <p @click="backTop" class="backTop">
                    <i class="el-icon-upload2"></i>
                </p>
        </div>
        <div class="top">
            <div class="topList">
                <h3 @click="boxshow = !boxshow">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                    <span>药品分类</span>
                    <div class="topList-list" v-show="boxshow" @mouseleave="boxshow=false">
                        <ul>
                            <li
                                v-for="(item,index) in categoryList"
                                :key="index"
                                @click="goProductDetails(item.id,item.atOname)"
                            >
                                <span>{{item.atOname}}</span>
                                <i class="el-icon-arrow-right" aria-hidden="true"></i>
                            </li>
                        </ul>
                    </div>
                </h3>
                <ul class="nav">
                    <li
                        v-for="(item,index) in categoryList5"
                        :key="index"
                        @click="goProductDetails(item.id,item.atOname)"
                    >{{item.atOname}}</li>
                </ul>
            </div>
            <div class="btmList">
                <!-- <swiper :options="swiperOption">
                    <swiper-slide v-for="(item,index) in CarouselList" :key="index">
                        <img :src="item.picture" style="width:100%" @click="goDetail(item.spSpgl)" />
                    </swiper-slide>
                    <div class="swiper-pagination" id="pagination" slot="pagination"></div>
                </swiper> -->
                <el-carousel class="top-carousel" height="426px" :loop="true">
                <el-carousel-item
                    v-for="(item,index) in CarouselList"
                    :key="index"
                    class="carousel-img-outer common-img-outer"
                >
                    <!-- 为0跳h5 -->
                    <a :href="item.urlLink" v-if="item.dictId == '0'">
                        <img :src="item.picture?$store.state.imgUrl+item.picture:''"  alt />
                    </a>
                    <!-- <a :href="item.urlLink"> -->
                    <img
                        :src="item.picture?$store.state.imgUrl+item.picture:''"
                        style="width:100%;height:426px;cursor: pointer;"
                        alt
                        @click="goDetail(item.spSpgl)"
                        v-else
                    />
                    <!-- </a> -->
                </el-carousel-item>
            </el-carousel>
            </div>
        </div>
        <div class="main">
            <div class="Recommend">
                <div class="RecommendLeft">
                    <img src="@/assets/img/zhogyiyao.png" alt />
                </div>
                <div class="RecommendRight">
                    <swiper :options="swiperOption2" ref="mySwiper2">
                        <!-- slides -->
                        <swiper-slide v-for="(item,index) in IndexByRecommendList" :key="index">
                            <div class="RecommendList" @click="goDetail(item.id)">
                                <div class="imgs">
                                    <img :src="$store.state.imgUrl+item.atCoverUrl" alt />
                                </div>
                                <p>{{item.atSpmc}}</p>
                            </div>
                        </swiper-slide>
                        <!-- Optional controls以下按需使用 -->
                        <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
                        <!--上一项-->
                        <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
                        <!--下一项-->
                    </swiper>
                </div>
            </div>
            <div class="list1">
                <div class="list1-left">
                    <img :src="CommodityList1&&CommodityList1.picture?$store.state.imgUrl+CommodityList1.picture:''" alt class="titss2" />
                    <img src="@/assets/img/haoyao.png" alt class="titss" />
                    <div
                        class="details"
                        v-show="CommodityList1&&CommodityList1.showFlag"
                        @click="goDetail(CommodityList1.spSpgl)"
                    >
                        <p>
                            <span>查看详情</span>
                            <i class="fa fa-angle-double-right fa-2" aria-hidden="true"></i>
                        </p>
                    </div>
                </div>
                <div class="list1-right">
                    <div
                        class="right-lists"
                        v-for="(item,index) in CommodityList"
                        :key="index"
                        @click="goDetail(item.spSpgl)"
                        v-if="item.showFlag"
                    >
                        <div class="RecommendList RecommendList2">
                            <div class="imgs">
                                <img :src="$store.state.imgUrl+item.atCoverUrl" alt />
                            </div>
                            <p>{{item.atSpmc}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <h3 class="shopList">
                <span class="shopListL">
                    <i class="fa fa-gift"></i>
                    活动药品
                </span>
                <span class="shopListR" @click="goProductDetails('huodong','活动药品')">
                    查看详情
                    <i class="fa fa-angle-double-right fa-2"></i>
                </span>
            </h3>
            <div class="Product1">
                <div class="ProductList" style="height:auto;" v-for="(item,index) in ActivitieList" :key="index">
                    <div class="ProductImg" style="height:176px;" @click="goDetail(item.id)">
                        <img :src="$store.state.imgUrl+item.atCoverUrl" alt />
                    </div>
                    <div class="Product">
                        <div class="ProductW">
                            <p class="p1">
                                <span class="tit">{{item.pinyinName}}</span>
                                <span class="tit2" v-if="item.atZkbl&&!item.groupId&&item.optYhlx !=2">{{item.atZkbl}}折</span>
                                <span v-if="item.optYhlx == 2" class="tg">团购</span>
                                <span class="tit2 tit2" v-if="false">{{item.optYhlx}}</span>
                            </p>
                            <p class="p2" @click="goDetail(item.id)">{{item.atSpmc}}</p>
                        </div>
                        <div class="p3">
                            <p class="money">
                                <span v-if="item.optYhlx==3" class="buyPrice">
                                    ￥{{item.atYpdj}}
                                </span>
                                <span v-if="item.optYhlx==2 || item.optYhlx==1">
                                    <span class="buyPrice">
                                        ￥{{item.atYhjg}}
                                    </span>
                                    <span class="oldPrice">
                                        ￥{{item.atYpdj}}
                                    </span>
                                </span>
                            </p>
                            <p class="rightBox">
                                月销：{{ item.monthSaleCount }}
                            </p>
                        </div>
                    </div>
                </div>
            </div> -->
            <h3 class="shopList">
                <span class="shopListL">
                    <i class="fa fa-shopping-bag"></i>
                    主打药品
                </span>
                <span class="shopListR" @click="goProductDetails('zhuda','主打药品')">
                    查看详情
                    <i class="fa fa-angle-double-right fa-2"></i>
                </span>
            </h3>
            <div class="Product2">
               
                <div class="ProductList ProductList2" v-for="(item,index) in MainList" :key="index">
                    <div class="ProductImg" style="height:137px;"  @click="goDetail(item.id)">
                        <img :src="$store.state.imgUrl+item.atCoverUrl" alt />
                    </div>
                    <div class="Product">
                        <div class="ProductW">
                            <p class="p1">
                                <span class="tit">{{item.pinyinName}}</span>
                                <span class="tit2" v-if="item.atZkbl">{{item.atZkbl}}折</span>
                                <span class="tit2 tit2" v-if="false">{{item.optYhlx}}</span>
                            </p>
                            <p class="p2" @click="goDetail(item.id)">{{item.atSpmc}}</p>
                        </div>
                        <div class="p3">
                              <p class="money">
                                <span v-if="item.optYhlx==3" class="buyPrice">
                                    ￥{{item.atYpdj}}
                                    <!-- <i>/{{item.atBzgg}}</i> -->
                                </span>
                                <span v-if="item.optYhlx==2 || item.optYhlx==1">
                                    <span class="buyPrice">
                                        ￥{{item.atYhjg}}
                                        <!-- <i>/{{item.atBzgg}}</i> -->
                                    </span>
                                    <span class="oldPrice">
                                        ￥{{item.atYpdj}}
                                        <!-- <i>/{{item.atBzgg}}</i> -->
                                    </span>
                                </span>
                            </p>
                            <p class="rightBox">
                                月销：{{ item.monthSaleCount }}
                            </p>
                            <!-- <p class="car" @click="addCar(item.id)">
                                <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                            </p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IndexBottom from "@/components/ShoppingMall/IndexBottom";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
    name: "Home",
    data() {
        return {
            hover1: false, //个人中心
            hover2: false, //购物车
            hover3: false, //二维码
            userId: "",
            boxshow: false, //分类show
            categoryList: [], //商品分类
            categoryList5: [], //商品分类(推荐的五条)
            CarouselList: [], //轮播图
            CommodityList: [], //精品好药
            CommodityList1: {}, //精品好药第1条
            IndexByRecommendList: [], //中药推荐
            ActivitieList: [], //活动
            MainList: [], //主打
            list: [1, 2, 3],
            list2: [1, 2, 3, 4, 5, 6, 7, 8],
            swiperOption: {
                loop: true,
                speed: 800,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                direction: "horizontal",
                slidesPerView: 1,
                grabCursor: true,
                observeParents: true,
                observer: true,
                pagination: {
                    el: ".swiper-pagination",
                    paginationClickable: true,
                    autoplay: {
                        delay: 5000,
                        stopOnLastSlide: false,
                        disableOnInteraction: true
                    },
                    loop: true
                }
            },
            swiperOption2: {
                loop: true,
                speed: 800,
                autoplay: false,
                direction: "horizontal",
                slidesPerView: 5,
                grabCursor: true,
                observeParents: true,
                observer: true,
                 autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                //左右点击
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            }
        };
    },
    components: {
        IndexBottom: IndexBottom,
        swiper,
        swiperSlide
    },
    created() {
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
             this.userId = this.userInfo.id;
        }
        this.getType(); //分类
        this.getCarousel(); //轮播图
        this.getCommodity(); //精品好药
        this.getRecommend(); //推荐
        this.getActivitie(); //活动
        this.getMain(); //主打
    },
    mounted() {},
    methods: {
        goCar() {
            //购物车
            if (this.userId) {
                this.$router.push({ path: "/car" });
            } else {
                this.$confirm("您还未登录，是否登录", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$router.push({ path: "/login" });
                    })
                    .catch(() => {});
            }
        },
        goPersonal() {
            //个人中心
            if (this.userId) {
                if (sessionStorage.getItem("YS") == "false") {
                    //当前不是医师
                    this.$router.push({ path: "/PersonalCenter" });
                } else {
                    this.$router.push({ path: "/personalFiles" });
                }
            } else {
                this.$confirm("您还未登录，是否登录", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$router.push({ path: "/login" });
                    })
                    .catch(() => {});
            }
        },
        backTop() {
            //返回顶部
            document
                .getElementById("ShopIndex")
                .scrollIntoView({ behavior: "smooth" });
        },
        getType() {
            //分类渲染
            let url = "/spfl/getListBySpgl";
            let params = {flType:1};
            this.$http.post(url,params).then(res => {
                if (res.data.code == 200) {
                    console.log(res);
                    this.categoryList = res.data.data;
                    console.log(this.categoryList);
                    for (var i = 0; i < this.categoryList.length; i++) {
                        if (this.categoryList.length < 5) {
                            this.categoryList5.push(this.categoryList[i]);
                        } else {
                            if (i < 6) {
                                this.categoryList5.push(this.categoryList[i]);
                            }
                        }
                    }
                }
            });
        },

        goProductDetails(id, name) {
            //分类跳转
            this.$router.push({ path: "/commodity/" + id + "/" + name });
        },
        getRecommend() {
            //推荐
            let url = "/spgl/indexByRecommend";
            this.$http.post(url).then(res => {
                if (res.data.code == 200) {
                    // console.log(res);
                    this.IndexByRecommendList = res.data.data;

                    // console.log(this.IndexByRecommendList);
                }
            });
        },
        getActivitie() {
            //活动
            let url = "/spgl/indexByActivitie";
            this.$http.post(url).then(res => {
                if (res.data.code == 200) {
                    console.log(res);
                    this.ActivitieList = res.data.data;
                    // console.log(this.ActivitieList);
                }
            });
        },
        getMain() {
            //主打
            let url = "/spgl/indexByMain";
            this.$http.post(url).then(res => {
                if (res.data.code == 200) {
                    console.log(res);
                    this.MainList = res.data.data;
                    // console.log(this.MainList);
                }
            });
        },
        getCommodity() {
            //精品好药
            let url = "/treasuresCommodity/listTreasuresCommodity";
            this.$http.post(url).then(res => {
                if (res.data.code == 200) {
                    console.log(res);
                    this.CommodityList1 = res.data.data[0];
                    let CommodityList = res.data.data;
                    for (var i = 0; i < CommodityList.length; i++) {
                        if (i > 0) {
                            this.CommodityList.push(CommodityList[i]);
                        }
                    }
                    console.log(this.CommodityList);
                }
            });
        },
        getCarousel() {
            //轮播图
            let url = "/commodityCarousel/listCommodityCarousel";
            this.$http.post(url).then(res => {
                if (res.data.code == 200) {
                    console.log(res);
                    this.CarouselList = res.data.data;
                    console.log(this.CarouselList);
                }
            });
        },
        goDetail(id) {
            //跳转详情
            console.log(id);
            this.$router.push({ path: "/ProductDetails/" + id });
        },
        addCar(id) {
            //轮播图
            let url = "/gwcgl/save";
            var params = {};
            if (this.userId) {
                params.userId = this.userId;
                params.spSpgl = id;
                params.atSpsl = "1";
                this.$http.post(url, params).then(res => {
                    if (res.data.code == 200) {
                        console.log(res);
                        this.$message({
                            message: "添加购物车成功！",
                            type: "success"
                        });
                    }
                });
            } else {
                this.$confirm("您还未登录，是否登录", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$router.push({ path: "/login" });
                    })
                    .catch(() => {});
            }
        }
    }
};
</script>

<style scoped>
#ShopIndex {
    max-width: 1440px;
    max-width: 80%;
    width: 1024px;
    margin: 0px auto;
}
.bottomW {
    background-color: #fbfbfb;
}
.top {
    width: 100%;
    height: 468px;
    background: #fff;
}

.btmList {
    width: 100%;
    height: 426px;
}
.swiper-container {
    width: 100%;
    height: 100%;
}
.Recommend {
    width: 100%;
    height: 220px;
    margin-top: 20px;
    border: 1px solid #eee;
    background: #fff;
}
.RecommendLeft {
    float: left;
    width: 15%;
    height: 180px;
    margin-top: 20px;
    display: table-cell;
    text-align: center;
}
.RecommendLeft img {
    width: 80%;
    height: auto;
    vertical-align: middle;
}
.RecommendRight {
    float: left;
    width: 85%;
    height: 180px;
    margin-top: 20px;
}
.RecommendList {
    float: left;
    width: 95%;
    margin: 0 auto;
}
.RecommendList2 {
    background: #fff;
    width: 100%;
    padding-bottom: 10px;
}
.RecommendList2 .imgs {
    width: 100%;
    height:130px;
    overflow: hidden;
}
.RecommendList2 .imgs img {
    display: block;
    width: 100%;
    min-height:130px;
}
.RecommendList:last-child {
    margin-right: 0;
}
.RecommendList .imgs {
    width: 100%;
    height: 119px;
    overflow: hidden;
}
.imgs img {
    display: block;
    width: 100%;
    min-height:119px;
}
.RecommendList p {
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    height: 60px;
    line-height: 18px;
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    padding: 10px 10px 0px 10px;
}
.RecommendList2 p {
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
    height: 60px;
    line-height: 18px;
}
.list1 {
    width: 100%;
    height: 410px;
    margin-top: 50px;
    background: #fff;
}
.list1 .list1-left {
    float: left;
    height: 410px;
    line-height: 410px;
    width: 23%;
    background: #ffc;
    display: table-cell;
    text-align: center;
    overflow: hidden;
    position: relative;
}
.list1-left .titss2 {
    height: auto;
    vertical-align: middle;
    min-width: 100%;
}
.list1-left .details {
    width: 100%;
    position: absolute;
    bottom: 40px;
}
.list1-left .titss {
    display: block;
    width: 80% !important;
    position: absolute;
    top: 30px;
    left: 10%;
}
.list1-left .details p {
    width: 98px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    margin: 0 auto;
    background: rgba(128, 94, 22, 0.3);
    cursor: pointer;
}
.list1 .list1-right {
    float: right;
    height: 100%;
    width: 75%;
}
.right-lists {
    float: left;
    width: 23.8%;
    margin-right: 1.5%;
    margin-top: 15px;
}
.right-lists:nth-of-type(1) {
    margin-top: 0;
}
.right-lists:nth-of-type(2) {
    margin-top: 0;
}
.right-lists:nth-of-type(3) {
    margin-top: 0;
}
.right-lists:nth-of-type(4) {
    margin-right: 0;
    margin-top: 0;
}
.right-lists:nth-of-type(8) {
    margin-right: 0;
}
.shopList {
    width: 100%;
    height: 64px;
    line-height: 64px;
    font-weight: 500;
    border-bottom: 2px solid #ccc;
    margin-bottom: 0;
}
.shopListL {
    float: left;
    width: 140px;
    font-size: 24px;
    color: #333;
}
.shopListL i {
    color: #f00;
}
.shopListR {
    float: right;
    width: 100px;
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    color: #999;
    margin-top: 23px;
    cursor: pointer;
}

#ShopIndex .swiper-button-prev:after,
#ShopIndex .swiper-button-next:after {
    color: #fff;
    transform: scale(0.3);
}
#ShopIndex .swiper-button-prev.swiper-button-black,
#ShopIndex .swiper-button-next.swiper-button-black {
    background: rgba(187, 187, 187, 0.8);
    width: 25px;
    height: 25px;
    border-radius: 50%;
}
.ProductList2 {
    height: 210px!important;
    margin-bottom: 15px;
}
.ProductList2 .Product{
    width: 100%;
    height: 70px!important;
}
.ProductList2 .Product .p3{
    width: 100%;
    margin-top: 5px!important;
}
/* 商品列表样式 */
.Product1,
.Product2 {
    width: 100%;
}
.Product1::after {
    content: "";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
}
.Product2::after {
    content: "";
    display: block;
    visibility: hidden;
    height: 0;
    clear: both;
}
.ProductList {
    float: left;
    width: 24%;
    /* height: 340px; */
    margin: 20px 13px 0 0;
}
.ProductList2 {
    float: left;
    width: 18.7%;
    height: 200px;
    margin: 20px 13px 0 0;
}
.ProductList:nth-child(4n + 4) {
    margin-right: 0;
}
.ProductList2:nth-child(4n + 4) {
    margin-right: 13px;
}
.ProductList2:nth-child(5n + 5) {
    margin-right: 0;
}
.ProductList .ProductImg {
    width: 100%;
    height: 137px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
}
.ProductImg img {
    width: 100%;
    min-height: 100%;
}
.Product {
    width: 100%;
    height: 20%;
    background: #fff;
    /* margin-top: 10px; */
}
.Product .ProductW {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 5px;
}
.Product .ProductW .p1{
    float: right;
    width: 26%;
}
.Product .ProductW .p2{
    font-size: 15px;
    float: left;
    width: 130px;
    height: 25px;
    line-height: 25px;
    white-space: nowrap!important; /* 确保文本在一行内显示 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 使用省略号表示文本溢出 */
}
.Product .p3 .rightBox{
    font-size: 12px;
    float: right;
    text-align: right;
    margin-right: 10px;
    height: 25px;
    line-height: 27px;
    color: #aaa;
}
.ProductW::after{
    content: "";
    display: block;
    visibility: hidden;
    overflow: hidden;
    clear: both;
}

.Product .p1 {
    width: 100%;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
}
.Product .p1 .tit {
    display: block;
    float: left;
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #909090;
    margin-left:5px;
}
.Product .p1 .tit2 {
    display: block;
    float: right;
    height: 16px;
    line-height: 16px;
    width: 35px;
    text-align: center;
    border: 1px solid #f74320;
    border-radius: 3px;
    background: #ffece8;
    margin-right: 10px;
    color: #f74320;
    margin-top: 5px;
    padding: 0 3px;
}
.Product .p1 .tit2 .tg {
    background: #e8f6ff;
    color: #56c7fc;
    border: 1px solid #63baf2;
     border-radius: 3px;

}
.Product .p1 .tg {
    display: block;
    float: right;
    height: 16px;
    line-height: 16px;
    width: 35px;
    text-align: center;
    background: #e8f6ff;
    color: #56c7fc;
    border: 1px solid #63baf2;
    margin-right: 10px;
    margin-top: 5px;
    border-radius: 3px;
}

.Product .p1 .tit22 {
    border: 1px solid #64b9f2;
     border-radius: 3px;
    background: #e8f7fe;
    color: #64b9f2;
}
.Product .p2 {
    height: 40px;
    line-height: 20px;
    color: #666;
    margin-top: 5px;
    cursor: pointer;
    margin-left: 5px;
}
.Product .p3 {
    width: 100%;
    height: 25px;
    /* margin-top: 20px; */
}
.Product .p3 .money {
    float: left;
    width: 50%;
    text-indent: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.p3 .money span {
    color: #f74320;
    font-size: 16px;
    font-weight: 600;
}
.p3 .money i {
    color: #999;
    font-size: 16px;
    font-style: normal;
}
.Product .p3 .car {
    float: right;
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    margin-right: 10px;
    /* margin-top:5px; */
    background: #f74320;
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
}
.p3 .money .oldPrice {
    text-decoration: line-through;
    font-size: 12px;
    color: #999;
}
.money .buyPrice {
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/ShoppingMall/ShopIndex.vue